import { render, staticRenderFns } from "./PerformanceStudents.vue?vue&type=template&id=25c0e73a"
import script from "./PerformanceStudents.vue?vue&type=script&lang=js"
export * from "./PerformanceStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c0e73a')) {
      api.createRecord('25c0e73a', component.options)
    } else {
      api.reload('25c0e73a', component.options)
    }
    module.hot.accept("./PerformanceStudents.vue?vue&type=template&id=25c0e73a", function () {
      api.rerender('25c0e73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/chart/PerformanceStudents.vue"
export default component.exports